import { motion } from 'framer-motion';
import Footer from '../components/Footer';

const OperationsOrganizationPage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <div>
      <section className="pt-32 pb-20 bg-gradient-to-br from-tev-green to-tev-green-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-5xl font-bold mb-6">How Our Operations Are Organised</h1>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              Value chain approach for quality and efficiency
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="mb-16"
          >
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-8 rounded-xl">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">Value Chain Approach</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                We take a value chain approach in our operations. This is to ensure that end-to-end, our end-products meet the highest quality 
                and production standards. This also assists us to manage our supply chains in an effective and efficient manner.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Our Group operations are therefore classified under three strategic business units, each overseen and led by qualified experts. 
                These comprise Agronomy, Value Addition and Trading.
              </p>
            </div>
          </motion.div>

          {/* Strategic Business Units */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="space-y-8"
          >
            {/* Agronomy SBU */}
            <motion.div
              variants={itemVariants}
              className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden"
            >
              <div className="bg-gradient-to-r from-green-600 to-green-700 p-6">
                <h3 className="text-2xl font-bold text-white flex items-center">
                  <i className="fas fa-seedling mr-3"></i>
                  Agronomy
                </h3>
              </div>
              <div className="p-6">
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">Ag. Inputs</h4>
                    <p className="text-gray-600 text-sm">Quality agricultural inputs and supplies</p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">Seed Prod'n & Irrigation</h4>
                    <p className="text-gray-600 text-sm">Seed production and irrigation services</p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">Primary Production</h4>
                    <p className="text-gray-600 text-sm">Commercial farming operations</p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Value Addition SBU */}
            <motion.div
              variants={itemVariants}
              className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden"
            >
              <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-6">
                <h3 className="text-2xl font-bold text-white flex items-center">
                  <i className="fas fa-industry mr-3"></i>
                  Value Addition
                </h3>
              </div>
              <div className="p-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">Agroprocessing</h4>
                    <p className="text-gray-600 text-sm">Modern agro-processing facilities</p>
                  </div>
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">Value Addition</h4>
                    <p className="text-gray-600 text-sm">Product enhancement and quality assurance</p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Trading SBU */}
            <motion.div
              variants={itemVariants}
              className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden"
            >
              <div className="bg-gradient-to-r from-purple-600 to-purple-700 p-6">
                <h3 className="text-2xl font-bold text-white flex items-center">
                  <i className="fas fa-chart-line mr-3"></i>
                  Trading
                </h3>
              </div>
              <div className="p-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">Trading</h4>
                    <p className="text-gray-600 text-sm">Domestic and international trading operations</p>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">Exports & Domestic</h4>
                    <p className="text-gray-600 text-sm">Export and domestic market distribution</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OperationsOrganizationPage;
